import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { z } from 'zod';
import { createAuthMutation } from '../auth-http-client';

export const createBlockCashdeskMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/cashdesk/lock/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(z.null()),
		},
	});
